import { Driver, Order } from '../types';
import { getDriverDailyStats } from './driverDailyStats';

export interface DriverDailyStatsRow {
  driver_id: string;
  date_key: string;
  deliveries_count: number;
}

export const getLocalDateKey = (date: Date = new Date()): string => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

export const getDriverStoredDailyDeliveries = (driver: Driver, now: Date = new Date()): number => {
  if (driver.dailyDeliveriesDate !== getLocalDateKey(now)) return 0;
  return Math.max(0, driver.dailyDeliveriesCount || 0);
};

export const getDriverTodayDeliveryCount = (
  orders: Order[],
  driver: Driver,
  now: Date = new Date()
): number => {
  const orderCount = getDriverDailyStats(orders, driver.id, now).deliveries;
  const storedCount = getDriverStoredDailyDeliveries(driver, now);
  return Math.max(orderCount, storedCount);
};

export const applyDriverDailyStats = (
  drivers: Driver[],
  rows: DriverDailyStatsRow[] = [],
  now: Date = new Date()
): Driver[] => {
  const todayKey = getLocalDateKey(now);
  const countByDriverId = new Map(
    rows
      .filter((row) => row.date_key === todayKey)
      .map((row) => [row.driver_id, Math.max(0, row.deliveries_count || 0)])
  );

  return drivers.map((driver) => {
    const persistedCount = countByDriverId.get(driver.id);
    if (persistedCount === undefined) return driver;
    return {
      ...driver,
      dailyDeliveriesDate: todayKey,
      dailyDeliveriesCount: Math.max(getDriverStoredDailyDeliveries(driver, now), persistedCount),
    };
  });
};

export const incrementDriverDailyDeliveries = (
  driver: Driver,
  completedAt: number = Date.now()
): Driver => {
  const completedDateKey = getLocalDateKey(new Date(completedAt));
  const currentCount = driver.dailyDeliveriesDate === completedDateKey
    ? Math.max(0, driver.dailyDeliveriesCount || 0)
    : 0;

  return {
    ...driver,
    dailyDeliveriesDate: completedDateKey,
    dailyDeliveriesCount: currentCount + 1,
  };
};
